export default "__VITE_ASSET__D76ZtGyI__"